<main @fade>
  <form [formGroup]="form" (ngSubmit)="chooseCategory()" [nbSpinner]="loading">
    <nb-card>
      <nb-card-body>
        @if (fullChosenCatalogs.length > 0) {
          <label class="label" i18n="@@VybrannyeRazdely">Выбранные разделы</label>
          <nb-tag-list>
            @for (catalog of fullChosenCatalogs; track catalog.id) {
              <nb-tag appearance="outline" status="primary" (remove)="removeCatalog(catalog)" [removable]="true" [text]="catalog.header"/>
            }
          </nb-tag-list>
        }

        @if (fullChosenCatalogs?.length) {
          <label class="label" i18n="@@VybratDopolnitelnyeRazdely">Выбрать дополнительные разделы</label>
        }
        <p>
          <ng-select [items]="categories"
                     [virtualScroll]="true"
                     (scroll)="onScroll($event)"
                     (scrollToEnd)="onScrollToEnd()"
                     [minTermLength]="2"
                     size="small"
                     [compareWith]="compareCategories"
                     [loading]="loadingCategories"
                     [typeahead]="catalogInput$"
                     [clearable]="true"
                     (clear)="clearSearch()"
                     (change)="changeSelectedCatalog($event)"
                     formControlName="category"
                     typeToSearchText="Пожалуйста, введите 2 или более символов"
                     i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText"
                     placeholder="Введите название категории"
                     i18n-placeholder="@@CatalogAutocompleteLabel"
          >
            <ng-template ng-header-tmp>
              <small i18n="@@ZagruzhenoIz" class="form-text text-muted">Загружено {{ loadedElements }} из {{ totalElements }}</small>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ getOptionLabel(item) }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div>{{ getOptionLabel(item) }}</div>
            </ng-template>
          </ng-select>
        </p>

        <div class="category">
          <div class="cascader-table-root">
            <div class="cascader-table-row">
              @for (categoryLevel of categoriesByLevels; track $index) {
                <ul class="cascader-table-column">
                  @for (category of categoryLevel; track category.id) {
                    <li class="cascader-table-category" (click)="chooseCascadeCategory(category)" [ngClass]="{active: isActive(category)}">
                      <span class="header">{{ category.header }}</span>
                      @if (!category.lastLevel) {
                        <nb-icon class="cascader-table-categoryHasChildIcon" icon="chevron-right"/>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer>
        <button nbButton [disabled]="form.invalid || !isCategoryLevelAppropriate()" type="submit" status="primary" i18n="@@ChooseCategoryButton">Выбрать</button>
        @if (permissionsService && !permissionAllowed && category.value) {
          <small class="text-danger" i18n="@@NetPravDlyaSozdaniyaV">Нет прав для создания в этом разделе</small>
        }
      </nb-card-footer>
    </nb-card>
  </form>
</main>
